import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomerPartNumberModel } from "@tCooneyBrothers/ApiModels";
import {
    deleteCustomerPartNumber as deleteCustomerPartNumberApi,
    getCustomerPartNumbers,
} from "@tCooneyBrothers/Services/CustomerPartNumberService";
import { CustomApiHandler, CustomHandlerWithResult } from "@tCooneyBrothers/Store/CustomHandlerCreator";

export interface DeleteCpnParameter {
    id: string;
    productId: string;
}

type HandlerType = CustomHandlerWithResult<
    DeleteCpnParameter,
    {
        apiResult: CustomerPartNumberModel[] | void;
    },
    {}
>;

// export const PopulateApiParameter: HandlerType = props => {
//     props.apiParameter = props.parameter;
// };

export const RequestDataFromApi: HandlerType = async props => {
    // eslint-disable-next-line no-console
    const deleteCustomerPartNumberApiResult: any = await deleteCustomerPartNumberApi(props.parameter);
    props.result = {
        apiResult: deleteCustomerPartNumberApiResult,
    };
};

export const DispatchResetCustomerPartNumber: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomerPartNumber/Reset",
    });
};

export const DispatchResetCustomerPartNumberWishLists: HandlerType = props => {
    props.dispatch({
        type: "Data/WishListLines/Reset",
    });
    props.dispatch({
        type: "Data/WishLists/Reset",
    });
};

export const DispatchResetCustomerPartNumberCart: HandlerType = props => {
    props.dispatch({
        type: "Data/Carts/Reset",
    });
};

export const DispatchCustomerPartNumberDelete: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomerPartNumber/Delete",
        action: props.result.apiResult,
    });
};

export const chain = [
    //    PopulateApiParameter,
    RequestDataFromApi,
    DispatchResetCustomerPartNumber,
    DispatchCustomerPartNumberDelete,
    DispatchResetCustomerPartNumberWishLists,
    DispatchResetCustomerPartNumberCart,
];

const deleteCustomerPartNumber = createHandlerChainRunner(chain, "DeleteCustomerPartNumber");
export default deleteCustomerPartNumber;
